import { setDataValue } from '../../form-sync';

export default {
    setDataValue,

    goToPage(state, page) {
        state.data.page = page;
    },

    setSearching(state, value) {
        state.searching = value;
    },

    setNoSpacesFoundModalShown(state, value) {
        state.noSpacesFoundModalShown = value;
    },

    addResults(state, data) {
        if (!data.dragged) {
            state.initialResults = data.results;
        }
        state.results = data.results;
    },

    setSearchMeta(state, data) {
        state.meta = state.meta = data;
    },

    setCurrentSearch(state, data) {
        state.currentSearch = data;
    },

    toggleFilterVisibility(state) {
        state.filtersVisible = !state.filtersVisible;
    },

    setObtainedLocation(state, data) {
        state.obtainedLocation = data;
    },

    showSearchComponent(state, component) {
        state.searchComponents.map = component === 'map';
        state.searchComponents.list = component === 'list';
    },

    showSearchListComponent(state) {
        state.searchComponents.list = true;
    },

    showSearchMapComponent(state) {
        state.searchComponents.map = true;
    },

    setSearchRentalType(state, data) {
        state.data.rental = data;
    },

    setResults(state, data) {
        state.results = data;
    },
};
